import { Helmet } from 'react-helmet';
import logoError404 from '../../assets/imgs/logo-error-404.svg';
import styles from './404.module.css';

export const NotFoundPage = () => {
  return (
    <div className={styles.notFoundPage}>
      <Helmet>
        <title>404 | Teidore</title>
      </Helmet>
      <img src={logoError404} alt='error 404' />
      <h3>Error 404</h3>
      <p>
        Sorry, but the page you are looking for could not be found. Try checking
        the URL for errors and refreshing the page.
      </p>
    </div>
  );
};
